export default __webpack_public_path__ + "static/media/speciality1.610226e8.jpg";